
<div class="row">
	<div class="col-xl-12">
<div class="kt-portlet">
	<div class="kt-portlet__body">
		<div class="kt-section">
				<form class="example-container" [formGroup]="uploadForm">
					<p>
						<mat-form-field class="mt-3">
							<mat-label>Select type</mat-label>
							<mat-select formControlName="file_type">
								<mat-option *ngFor="let type of types" [value]="type.value">
									{{ type.text }}
								</mat-option>
							</mat-select>
							<mat-error *ngIf="!uploadForm.get('file_type').valid && uploadForm.get('file_type').touched">Please select type</mat-error>
						</mat-form-field>
					</p>

					<p>
						<mat-form-field>
							<input matInput placeholder="Version #" formControlName="file_version">
							<mat-error *ngIf="!uploadForm.get('file_version').valid && uploadForm.get('file_version').touched">Please select type</mat-error>
						</mat-form-field>
					</p>

					<p>
						<mat-form-field class="example-form">
							<mat-label>Description</mat-label>
							<textarea matInput formControlName="file_desc"></textarea>
						</mat-form-field>
					</p>

					<!-- <mat-label>Compatible Versions</mat-label> -->

					<div *ngIf="uploadForm.get('file_type').value === 'aux'" class="row">
						<div class="col">
							<mat-card>
								<mat-card-header>
								  <mat-card-subtitle>Compatible Versions</mat-card-subtitle>
								</mat-card-header>
								<mat-card-content style="height: 150px;">
									<mat-chip-list>
										<mat-chip *ngFor="let chip of compVersions" selected="true" (click)="removeCompVersion(chip)" color="primary">
										  {{chip}}
										  <mat-icon matChipRemove style="color: red;" (click)="removeCompVersion(chip)">remove_circle</mat-icon>
										</mat-chip>
									  </mat-chip-list>
								</mat-card-content>
							  </mat-card>
						</div>
						<div class="col">
							<mat-card>
								<mat-card-header>
								  <mat-card-subtitle>In-Compatible Versions</mat-card-subtitle>
								</mat-card-header>
								<mat-card-content style="height: 150px;">
									<!-- <div class="add-chip" *ngFor="let chip of availableVersions">
										<div>
											<span class="text-left">{{chip.file_version}}</span>
											<mat-icon class="text-right" style="color: green;" (click)="addCompVersion(chip.file_version)">add_circle</mat-icon>
										</div>

									</div> -->
									<mat-chip-list>
										<mat-chip *ngFor="let chip of availableVersions" (click)="addCompVersion(chip)" selected="false">
										  {{chip}}
										  <mat-icon matChipRemove style="color: green;" (click)="addCompVersion(chip)">add_circle</mat-icon>
										</mat-chip>
									  </mat-chip-list>
								</mat-card-content>
							  </mat-card>
						</div>
					</div>


						<div class="uploadfilecontainer" (click)="fileInput.click()" ktDragDropDirective (onFileDropped)="uploadFile($event)">
							<h5 class="text-center" style="margin: 3% auto auto auto;"> <b>Drop</b> or <b>Browse</b> files.</h5>
							<input hidden formControlName="files_src" multiple type="file" #fileInput (change)="uploadFile($event.target.files)">
						</div>
						<!-- <mat-error *ngIf="fileError">Please select files</mat-error> -->

						  <!-- <mat-card class="card-container" *ngFor="let file of files;let i= index">
							<div class="card-container-right"> {{ file }}</div>
							<div class="card-container-left">
								<button (click)="deleteFile(i)" mat-icon-button style="margin-right: 10px;" matTooltip="Edit File">
									<mat-icon>delete_forever</mat-icon>
								</button>
							</div>
						</mat-card> -->



						<!-- <div class="box-style" *ngFor="let file of files;let i= index">
							<div class="row">
								<div class="col">
									<p style="margin: 10px 0 10px 10px;">{{ file }}</p>
								</div>
								<div class="col text-right">
									<ngb-progressbar class="col-10 mx-auto" style="margin: 10px 0px 0px 10px;" type="success" [value]="75" [striped]="true" [animated]="true">
										<i class="text-dark">50%</i>
									  </ngb-progressbar>
								</div>
							</div>
						</div> -->

						<div class="box-style mt-2" *ngFor="let file of files;let i= index">
							<!-- <div style="width: auto;" class="row"> -->
								<mat-progress-bar *ngIf="imgCardStatus[i].uploadProgress > 0" [color]="(imgCardStatus[i].matIcon === 'error')?'warn':'primary'" mode="buffer" value="{{imgCardStatus[i].uploadProgress}}"></mat-progress-bar>
							<!-- </div> -->
							<div class="row">
								<div class="col">
									<p style="margin: 10px 0 10px 10px;">{{ file }}</p>
								</div>
								<div class="col text-right">
									<button *ngIf="imgCardStatus[i].toolTip !== 'In Progress'" disabled="{{isUploadStarted}}" (click)="deleteAttachment(i)" mat-icon-button [ngClass]="imgCardStatus[i].css" matTooltip="{{imgCardStatus[i].toolTip}}">
										<mat-icon>{{imgCardStatus[i].matIcon}}</mat-icon>
									</button>
									<mat-spinner *ngIf="imgCardStatus[i].toolTip === 'In Progress'" style="margin: 10px 0 10px 10px;" matTooltip="In Progress" class="text-right ml-auto mr-3" [diameter]="16"></mat-spinner>
								</div>
							</div>
						</div>

						<!-- <div class="box-style mt-2" *ngFor="let file of files;let i= index">
							<mat-progress-bar mode="determinate" value="100"></mat-progress-bar>
							<div class="row">
								<div class="col">
									<p style="margin: 10px 0 10px 10px;">{{ file }}</p>
								</div>
								<div class="col text-right">
									<button disabled="false" (click)="deleteFile(i)" mat-icon-button style="color: red;" matTooltip="success">
										<mat-icon style="color: green;">check</mat-icon>
									</button>
								</div>
							</div>
						</div> -->


						  <!-- <mat-card *ngFor="let file of files;let i= index">
							<div class="row">
								<div class="col">
									<p>{{ file }}</p>
								</div>
								<div class="col text-right">
									<button (click)="deleteFile(i)" mat-icon-button style="justify-content: right;" matTooltip="Edit File">
										<mat-icon class="delete-file">delete_forever</mat-icon>
									</button>
								</div>
							</div>
						  </mat-card> -->

							<!-- <mat-icon>delete_forever</mat-icon> -->

						  <!-- <div  class="files-list" *ngFor="let file of files;let i= index">
							  <p style="margin: auto 0 auto 5%;"> {{ file }} </p>
							  <button class="delete-file" (click)="deleteAttachment(i)">

								<img src="../../../../../assets/media/drag-drop/Recycle_Bin_Full.png">
							  </button>
						   </div> -->

						   <div class="text-right mt-3">
							<button mat-raised-button (click)="onReset()" class="mat-danger">Cancel</button> &nbsp;
							<button mat-raised-button [disabled]="!uploadForm.valid || !files.length" (click)="onUpload()" color="primary">Submit</button>
						   </div>

						</form>
		</div>
</div>

</div>
</div>
